"use client";

import { useRouter } from "next/navigation";

interface ExternalUrlRedirectProps {
  redirectToExternal?: boolean;
  externalUrl?: string;
  openInNewTab?: boolean;
}

const ExternalUrlRedirect: React.FC<ExternalUrlRedirectProps> = ({
  redirectToExternal,
  externalUrl,
  openInNewTab,
}) => {
  const router = useRouter();

  const handleRedirect = () => {
    if (!externalUrl) return;

    if (openInNewTab) {
      // Open in new tab
      window.open(externalUrl, "_blank", "noopener,noreferrer");
      // Redirect current page to home
      router.push("/");
    } else {
      // Redirect in same tab
      router.push(externalUrl);
    }
  };

  // Show redirect button for external URLs
  if (redirectToExternal && externalUrl) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[var(--page-bg-color)]">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="mb-8">
            <svg
              className="mx-auto h-20 w-20 text-[var(--page-text-color)] opacity-60"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
          </div>
          <p className="homepage-text-lg text-[var(--page-text-color)] mb-6 leading-relaxed">
            {openInNewTab
              ? "Denne side åbner en ekstern hjemmeside i et nyt vindue"
              : "Du bliver omdirigeret til en ekstern hjemmeside"}
          </p>
          <div className="bg-[var(--card-bg-color)] border border-[var(--card-border-color)] rounded-lg p-4 mb-8">
            <p className="text-sm text-[var(--page-text-color)] break-all font-mono">
              {externalUrl}
            </p>
          </div>
          <button
            onClick={handleRedirect}
            className="py-3 px-8 homepage-text-lg font-medium rounded-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-0.5 
              bg-[var(--button-bg-color)] text-[var(--button-text-color)] border-[var(--button-border-color)]
              hover:bg-[var(--button-hover-bg-color)] hover:text-[var(--button-hover-text-color)] hover:border-[var(--button-hover-border-color)]"
          >
            {openInNewTab ? "Åbn i nyt vindue" : "Fortsæt til ekstern side"}
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default ExternalUrlRedirect;
